import { isSet, optionsToKeyValuePairs } from "../../../../../../utils/commonUtils";
import { computationRules1 } from "./DrugScreenCollection";

// Chart config from pulmonary.html (Pulmonary Function Test / Spirometry)
const pulmonaryFormConfig = {
    type: 'Tab',
    col: 'col-md-9',
    data: [
        {
            id: 'History',
            label: 'History',
            labelStyle: 'padding: 0;',
            data: [
                {
                    label: 'History',
                    hideHeader: true, // Single header: "History" + Yes/No in NewYesOrNoFields header only
                    cardBodyClassName: 'p-0',
                    fields: [
                        {
                            type: 'NewYesOrNoFields',
                            label: 'History',
                            col: 'col-12',
                            options: [{ label: 'Yes', value: 1 }, { label: 'No', value: 0 }],
                            defaultValues: {
                                history_chest_injury_surgery: 0,
                                history_high_bp: 0,
                                history_smoked_tobacco: 0,
                                history_full_meal: 0,
                                history_respiratory_infection: 0,
                                history_bronchodilator: 0,
                                history_restrictive_clothing: 0,
                                history_restrictive_garments: 0,
                                history_sinus_infection: 0,
                                history_feel_well: 0,
                                history_pneumothorax: 0,
                                history_aneurysm_thoracic: 0,
                                history_heart_attack_stroke: 0
                            },
                            list: [
                                { label: '1. In the last 6 weeks have you had a chest injury or surgery involving the eye, ear, chest, abdomen or been hospitalized for a heart attack? If Yes, your test will be scheduled 6 weeks after event', name: 'history_chest_injury_surgery', id: 'history_chest_injury_surgery' },
                                { label: "2. Are you under a physician's care for high blood pressure? If your blood pressure exceeds 161/110 you will need physician clearance", name: 'history_high_bp', id: 'history_high_bp' },
                                { label: '3. Within the last hour have you smoked tobacco? If yes, wait one hour before testing', name: 'history_smoked_tobacco', id: 'history_smoked_tobacco' },
                                { label: '4. Within the last hour have you taken a full meal? If yes, wait one hour before testing', name: 'history_full_meal', id: 'history_full_meal' },
                                { label: '5. Have you had a respiratory infection (flu, bronchitis, or pneumonia) in the last 3 weeks?', name: 'history_respiratory_infection', id: 'history_respiratory_infection' },
                                { label: '6. Have you used an inhaled bronchodilator (Ventolin, etc.) in the last 6 hours?', name: 'history_bronchodilator', id: 'history_bronchodilator' },
                                { label: '7. Are you wearing tight or restrictive clothing?', name: 'history_restrictive_clothing', id: 'history_restrictive_clothing' },
                                { label: '8. Are you wearing restrictive garments?', name: 'history_restrictive_garments', id: 'history_restrictive_garments' },
                                { label: '9. Recent sinus infection', name: 'history_sinus_infection', id: 'history_sinus_infection' },
                                { label: '10. Do you feel well today?', name: 'history_feel_well', id: 'history_feel_well' },
                                { label: '11. Do you have a history of pneumothorax (collapsed lung)? If Yes, you will need physician clearance.', name: 'history_pneumothorax', id: 'history_pneumothorax' },
                                { label: '12. Do you have a history of aneurysm or thoracic surgery? If Yes, you will need physician clearance.', name: 'history_aneurysm_thoracic', id: 'history_aneurysm_thoracic' },
                                { label: '13. Have you had a heart attack or stroke in the last month? If Yes, you will need physician clearance.', name: 'history_heart_attack_stroke', id: 'history_heart_attack_stroke' }
                            ]
                        }
                    ]
                },
                {
                    label:'Patient Signature & Comments',
                     labelStyle: "fw-semibold",
                    col:'col-12',
                    fields:[
                         {
                           label: 'Comments',
                           placeholder: 'Content',
                           type: 'TextArea',
                           name: 'patient_comments',
                           id: 'patient_comments',
                           col: 'col-md-6 col-12 border-0',
                           layout: 'stacked',
                           labelStyle: { paddingLeft: '0.75rem' },
                           style: { minHeight: '150px', resize: 'vertical' },
                           rows: 5,
                         },
                         {
                           label: "Signature",
                           type: 'NewSignature',
                           isLabel: false,
                           col: 'col-md-6 col-12 border-0',
                           name: 'driver_signature',
                           id: 'driver_signature',
                           required: true,
                         },
                    ]
                },
            ]
        },
        { id: 'Exam', label: 'Exam', data: [
             {
                    hideHeader: true,
                    cardBodyClassName: 'p-0',
                    fields: [
                        {
                            type: 'TrialYesOrNoTable',
                            label: 'Trial Number',
                            col: 'col-12',
                            options: [{ label: 'Yes', value: 1 }, { label: 'No', value: 0 }],
                            sections: [
                                {
                                    rows: [
                                        { label: 'Proper initial fit', nameBase: 'exam_proper_initial_fit' },
                                        { label: 'Positive pressure check', nameBase: 'exam_positive_pressure' },
                                        { label: 'Negative pressure teat check', nameBase: 'exam_negative_pressure' }
                                    ]
                                },
                                {
                                    sectionLabel: 'Fitting Result',
                                    rows: [
                                        { label: 'a. Normal breathing (Exercise Regimen)', nameBase: 'exam_normal_breathing' },
                                        { label: 'b. Deep breathing (Exercise Regimen)', nameBase: 'exam_deep_breathing' },
                                        { label: 'c. Turning head side to side (Exercise Regimen)', nameBase: 'exam_turning_head' },
                                        { label: 'd. Moving head up & down (Exercise Regimen)', nameBase: 'exam_moving_head' },
                                        { label: 'e. Reading', nameBase: 'exam_reading' },
                                        { label: 'f. Bend over or jog in place (Exercise Regimen)', nameBase: 'exam_bend_jog' },
                                        { label: 'g. Normal breathing (Exercise Regimen)', nameBase: 'exam_normal_breathing_2' }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    label: 'Fitting Result',
                    labelStyle: 'fw-semibold',
                    col: 'col-12',
                    fields: [
                        {
                            type: 'CheckBoxGroup',
                            col: 'col-12',
                            isLabel: false,
                            isVertical: true,
                            showContainerBorder: false,
                            options: [
                                { name: 'fitting_proper_fit', label: 'Proper fit' },
                                { name: 'fitting_incorrect_fit', label: 'Incorrect fit' },
                                { name: 'fitting_facial_hair', label: 'Facial hair interferes' },
                                { name: 'fitting_eyewear', label: 'Prescription eye wear interferes' },
                                { name: 'fitting_not_sensitive', label: 'Not sensitive to testing solution' },
                                { name: 'fitting_difficulty_breathing', label: 'Difficulty breathing' },
                                { name: 'fitting_others', label: 'Others' }
                            ]
                        }
                    ]
                },
                {
                    label: 'Review / Completion',
                    labelStyle: 'fw-semibold',
                    fields: [
                        {
                            type: 'ProviderSignOff',
                            col: 'col-12',
                            fields: [
                                { label: 'Signature PIN', name: 'provider_pin', col: 'col-12' },
                                { label: 'Signature', type: 'NewSignature', name: 'provider_signature', col: 'col-12' },
                                { label: 'Date', type: 'Date', name: 'signed_date', col: 'col-12' },
                                // { label: 'Suggested Result', placeholder: 'Not Started', type: 'TextInput', name: 'suggested_status', col: 'col-6' },
                                { label: 'Final Results', type: 'SelectList', name: 'status', statusBasedColor:true, col: 'col-12', options: [] },
                                { label: 'Activity Status', type: 'SelectList', name: 'activity_status',  statusBasedColor:true, col: 'col-12', options: [] },
                            ],
                        },
                    ],
                },
        ] },
        {
            id: 'Images',
            label: 'Images',
            data: []
        }
    ]
};

export const PulmonaryFunction = (props) => {
    const tabData = JSON.parse(JSON.stringify(pulmonaryFormConfig));
    const examTab = tabData.data.find((t) => t.id === 'Exam');
    if (examTab && examTab.data) {
        const reviewSection = examTab.data.find((s) => s.label === 'Review / Completion');
        if (reviewSection && reviewSection.fields && reviewSection.fields[0] && reviewSection.fields[0].fields) {
            const providerFields = reviewSection.fields[0].fields;
            const statusField = providerFields.find((f) => f.name === 'status');
            const activityStatusField = providerFields.find((f) => f.name === 'activity_status');

            // Previous options:
            // if (statusField) statusField.options = isSet(props.lookupsOptions?.['chartResult'], []);
            // if (activityStatusField) activityStatusField.options = optionsToKeyValuePairs(['Not Started', 'Ordered', 'Completed', 'Cancelled']);

            // New standard options:
            if (statusField) {
                statusField.options = optionsToKeyValuePairs(
                    [
                        "Not Started",
                        "Pending",
                        "Normal",
                        "Abnormal",
                        "Negative",
                        "Positive",
                        "Dispensed",
                        "Administered",
                        "Failed",
                        "Passed",
                        "Non-Negative",
                        "Cancelled",
                        "Inconclusive",
                    ],
                    false
                );
            }
            if (activityStatusField) {
                activityStatusField.options = optionsToKeyValuePairs(
                    [
                        "Not Started",
                        "Pending",
                        "Pending Lab Confirmation",
                        "Pending MRO Confirmation",
                        "Ready for Review",
                        "Completed",
                        "Cancelled",
                    ],
                    false
                );
            }
        }
    }

    const charts = [
        {
            type: 'Grid',
            col: 'col-md-3',
            data: [
                { type: 'PatientDetails', employeeDetails: props.employeeDetails, visitDetails: props.visitDetails },
                { type: 'CompanyDetails', companyDetails: props.companyDetails },
            ],
        },
        tabData,
    ];

    const defaultValue = {
        status: 'Not Started',
        suggested_status: 'Not Started',
        activity_status: 'Not Started',
    };

    const headers = [];

    return {
        charts,
        defaultValue,
        headers,
        computationFunction: (formData, key) => computationRules1(formData, key),
    };
};

// Commented out existing computation rules - now using shared computationRules1 from DrugScreenCollection.js
/*
// No linked updates: Final Results and Activity Status are independent for pulmonary.
const computationRules = (formData, key) => {
    return {};
};
*/